module.exports = __webpack_public_path__ + "img/CoolKids.242897eb.jpeg";